import { InfoCircleOutlined } from '@ant-design/icons/lib/icons';
import { Skeleton, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import AnimateHeight from 'react-animate-height';

import styles from './ServiceFee.module.scss';

const ServiceFee = ({
  inputFieldName,
  isRequired,
  offeringAmount,
  register,
  serviceFeeLoading,
  totalAmountToPay,
}) => {
  return (
    <>
      {isRequired ? (
        <div className="mb-4">
          <InfoCircleOutlined />{' '}
          <span>Powiększymy wybraną kwotę, aby pokryć opłaty serwisowe.</span>
        </div>
      ) : (
        <div className="input-group mt-0 mb-4">
          <input
            className="form-check-input"
            type="checkbox"
            id={inputFieldName}
            {...register(inputFieldName)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className="form-check-label" htmlFor={inputFieldName}>
            Chcę pokryć opłatę serwisową
          </label>

          <Tooltip
            className={styles.Tooltip}
            title={
              <>
                Zaznaczając to pole zgadzasz się przekazać nieznacznie wyższą darowiznę, aby pokryć
                opłaty serwisowe. Jeśli nie zaznaczysz tego pola koszt obsługi serwisowej poniesie
                obdarowany.
              </>
            }
          >
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      )}

      <AnimateHeight
        duration={500}
        height={offeringAmount !== null && offeringAmount !== '' ? 'auto' : 0}
      >
        Całkowita kwota darowizny:{' '}
        <strong data-testid="total-amount-to-pay">
          {serviceFeeLoading ? (
            <Skeleton
              data-testid="service-fee-skeleton"
              style={{ display: 'inline-block', width: 'auto' }}
              active
              title={false}
              paragraph={{ rows: 1, width: 20, style: { marginBottom: 0 } }}
            />
          ) : (
            totalAmountToPay
          )}{' '}
          zł
        </strong>
      </AnimateHeight>
    </>
  );
};

ServiceFee.propTypes = {
  inputFieldName: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  offeringAmount: PropTypes.number,
  register: PropTypes.func.isRequired,
  serviceFeeLoading: PropTypes.bool,
  totalAmountToPay: PropTypes.number,
};

export default ServiceFee;
